import { DAMO_AUTH_PATHS } from '@damotech/damoauth-lib';

export const AUTH_PATHS = {
  AUTH: '/auth',
  SIGN_IN: `/auth/${DAMO_AUTH_PATHS.SIGN_IN}`,
  REDIRECT: `/auth/${DAMO_AUTH_PATHS.REDIRECT}`,
};
